import { Link } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";

export const Navbar = ({ view = "hero", go = () => { } }) => {
  const [open, setOpen] = useState(false);
  const firstLinkRef = useRef(null);

  // Bloquear scroll del body cuando el menú está abierto
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      // foco al primer link
      setTimeout(() => firstLinkRef.current?.focus(), 0);
    } else {
      document.body.style.overflow = "";
    }
    return () => (document.body.style.overflow = "");
  }, [open]);

  // Cerrar con ESC
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const items = [
    { id: "hero", label: "Inicio" },
    { id: "diagram", label: "Flujo de trabajo" },
    { id: "podium", label: "Podium" },
    { id: "standings", label: "Tabla Posiciones" },
    { id: "login", label: "Login" },
  ];

  const Item = ({ id, label, idx }) => {
    const isActive = view === id;
    const common =
      "px-3 py-2 rounded transition font-medium text-left w-full md:w-auto";
    const active = "text-hitch";
    const hover = "text-gray-200 hover:text-hitch";
    return (
      <button
        ref={idx === 0 ? firstLinkRef : undefined}
        onClick={() => {
          go(id);
          setOpen(false);
        }}
        className={`${common} ${isActive ? active : hover}`}
        aria-current={isActive ? "page" : undefined}
      >
        {label}
      </button>
    );
  };

  return (
    <header className="sticky top-0 z-50 bg-gradient-to-r from-black to-black/95 shadow-md">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-8 py-3">
        {/* Brand */}
        <div className="flex items-center gap-3">
          <a href={'/'}>
          <img
            src="/partners/logo2.png"
            alt="Hitch"
            className="h-12 md:h-12 object-contain  sm:block"
          />
          </a>
          {/* <h1 className="text-xl md:text-2xl font-extrabold tracking-wide text-white">
            <span className="text-hitch">SOLUTION</span> DAY
          </h1> */}
        </div>

        {/* Desktop menu */}
        <div className="hidden lg:flex gap-4 md:gap-6 items-center">
          {items.map((it, i) => (
            <Item key={it.id} id={it.id} label={it.label} idx={i} />
          ))}
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          // className="inline-flex items-center justify-center rounded-lg p-2 text-gray-200 hover:text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:text-hitch"
          className="lg:hidden inline-flex items-center justify-center rounded-lg p-2 text-gray-200 hover:text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-red-500"
          aria-label="Abrir menú"
          aria-expanded={open}
          onClick={() => setOpen(true)}
        >
          {/* ícono hamburguesa */}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
          Menú
        </button>
      </nav>

      {/* Off-canvas mobile menu */}
      {/* Overlay */}
      <div
        className={`md:hidden fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
          }`}
        onClick={() => setOpen(false)}
      />

      {/* Drawer */}
      <aside
        className={`fixed top-0 right-0 h-full w-72 max-w-[80%] bg-gradient-to-b from-gray-900 to-black border-l border-white/10 shadow-2xl transition-transform duration-200 ${open ? "translate-x-0" : "translate-x-full"
          }`}
        role="dialog"
        aria-modal="true"
        aria-label="Menú de navegación"
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
          <div className="flex items-center gap-2">
            <span className="text-white font-bold">Menú Principal</span>
          </div>
          <button
            className="rounded-lg p-2 text-gray-300 hover:text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-red-500"
            aria-label="Cerrar menú"
            onClick={() => setOpen(false)}
          >
            {/* ícono cerrar */}
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path d="M6 6l12 12M18 6l-12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <div className="flex flex-col gap-1 p-4">
          {items.map((it, i) => (
            <Item key={it.id} id={it.id} label={it.label} idx={i} />
          ))}
          <div className="mt-3 border-t border-white/10 pt-3 text-xs text-white/50">
            © {new Date().getFullYear()} Solution Day
          </div>
        </div>
      </aside>
    </header>
  );
};
